<dhhp-my-profile [drawyerData]="RightNavData" [role]="userData?.roleName?.roleName" [profileUrl]="'profile'"
  [userData]="userData" [logOutUrl]="logOutUrl" [userprinciplename]="userprinciplename"
  [institutionname]="packageInstitutionsList" [isDisableSetting]="true" (emitEvent)="viewChanges($event)">
</dhhp-my-profile>
